import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v10h10v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V6h-8v2z"
}), 'TransformSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TransformSharp.js
// module id = 6907
// module chunks = 2